/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Angular service that handles general plan list actions.
 */
@Injectable({
  providedIn: 'root',
})
export class PlanListService {
  /**
   * Default Constructor.
   * @param http Angular http client.
   */
  constructor(private http: HttpClient) { }

  /**
   * Method that returns prices for Bulb plans.
   */
  getPlanListData() {
    return this.http.get('billing/prices') as Observable<any>;
  }

  /**
   * Method for checking out to stripe.
   * @param priceId  contains the price id of selected product.
   */
  createCheckoutSession(priceId) {
    return this.http.post('billing/checkout', { priceId }) as Observable<any>;
  }
}
